'use strict'

const ScrollTopButton = {
  ctxClass: '.scroll-top-button'
}

ScrollTopButton.init = function () {
  ScrollTopButton.bindEvents()
}

ScrollTopButton.bindEvents = function () {
  $(window).scroll(checkWindowPosition)
  $(ScrollTopButton.ctxClass).bind('click', ScrollTopButton.scrollTop)
}

ScrollTopButton.scrollTop = function (e) {
  $('html, body').animate({
    scrollTop: 0
  }, 600)
}

const checkWindowPosition = function (e) {
  if ($(e.target).scrollTop() > 400) {
    $(ScrollTopButton.ctxClass).fadeIn().css('display', 'flex')
  } else {
    $(ScrollTopButton.ctxClass).fadeOut()
  }
}

export { ScrollTopButton }
